module.exports = branding => {
  return `<mj-section padding="24px 16px 0px 16px">
    <mj-column>
      <mj-text line-height="30px" font-size="18px" align="left" color="${branding.secondaryColour || '#333333'}">
        <b>Need help?</b><br>Email support: <span style="color: ${branding.primaryColour || '#444444'}">support@reallinks.io</span>
      </mj-text>
    </mj-column>
  </mj-section>`;
};


// WEBPACK FOOTER //
// ./src/emails/components/footer.js